import "./style.css";
import { FaPython, FaJava, FaReact, FaHtml5, FaCss3Alt, FaGithub } from "react-icons/fa";
function App() {
  return (
    <div className="container">

      {/* Navigation Bar */}
      <nav className="navbar">
        <h2>Tessa Jimmi</h2>

        <div className="nav-links">
          <a href="#about">About</a>
          <a href="#skills">Skills</a>
          <a href="#projects">Projects</a>
          <a href="#contact">Contact</a>
        </div>
      </nav>

      {/* Hero Section */}
      <h1>Tessa Jimmi</h1>
      <h3>MCA Student | Software Developer</h3>

      <div className="buttons">
        <a href="https://github.com/Tessa63" target="_blank" rel="noreferrer">
          <button>GitHub</button>
        </a>

        <a
          href="https://www.linkedin.com/in/tessa-jimmi-721aa831b/"
          target="_blank"
          rel="noreferrer"
        >
          <button>LinkedIn</button>
        </a>
      </div>

      {/* About Section */}
      <div className="section" id="about">
        <h2>About Me</h2>

        <p>
          I am an MCA student at Muthoot Institute of Technology and Science.
          I enjoy building web applications and learning modern technologies.
        </p>
      </div>

      {/* Skills Section */}
      <div className="section" id="skills">

<h2>Skills</h2>

<div className="skills-grid">

<div className="skill">
<FaPython size={40}/>
<p>Python</p>
</div>

<div className="skill">
<FaJava size={40}/>
<p>Java</p>
</div>

<div className="skill">
<FaHtml5 size={40}/>
<p>HTML</p>
</div>

<div className="skill">
<FaCss3Alt size={40}/>
<p>CSS</p>
</div>

<div className="skill">
<FaReact size={40}/>
<p>React</p>
</div>

</div>

</div>

      {/* Projects Section */}
      <div className="section" id="projects">

        <h2>Projects</h2>

        <div className="card">
          <h3>Career Vista</h3>

          <p>
            Career prediction web application using Flask, Python, HTML,
            and CSS.
          </p>
          <a href="https://github.com/Tessa63" target="_blank" rel="noreferrer">
          <button>View Code</button>
          </a>
        </div>

        <div className="card">
          <h3>AI-Based Handwritten Answer Evaluation System</h3>

          <p>
            Automated handwritten answer evaluation system using OCR
            and BERT.
          </p>
        </div>

      </div>

      {/* Contact Section */}
      <div className="section" id="contact">

        <h2>Contact</h2>

        <p>Email: tessajimmy2003@gmail.com</p>

        <p>
          GitHub: <a href="https://github.com/Tessa63">github.com/Tessa63</a>
        </p>

        <p>
          LinkedIn:
          <a href="https://www.linkedin.com/in/tessa-jimmi-721aa831b/">
            tessa-jimmi
          </a>
        </p>

      </div>

    </div>
  );
}

export default App;